import usePrivateAxios from "@/common/api/usePrivateAxios";
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant";
import { MetaResponse } from "@/common/types/metaResponse";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { privateCompanyLeadsTransformer } from "../services/privateCompanyLeadsTransformer";

type usePrivateCompanyLeadsProps<T> = {
  filters?: {
    pageSize?: number,
    search?: string
    state?: string
    creatorId?: string
    showOnlyArchived?:boolean
  }
  mapper?: (data: any) => T
}

export const usePrivateCompanyLeads = <T,>({
  filters: { pageSize, search = '', state, creatorId, showOnlyArchived } = {},
  mapper,
}: usePrivateCompanyLeadsProps<T>) => {
  const privateAxios = usePrivateAxios()

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    ...rest
  } = useQuery({
    queryKey: ['privateCompanyLeads', pageSize, search, state, creatorId, showOnlyArchived],
    queryFn: () => {
      const params = {
        page_size: pageSize,
        search,
        'q[state_eq]': state,
        'q[archived_at_not_null]': showOnlyArchived ? true : undefined,
        'q[creator_id_eq]': creatorId
      };

      return privateAxios.get('/funnel/private_company_leads', {
        params
      })
    },
    select: (data: { data: { data: any[], meta: MetaResponse } }) => {
      return {
        data: (mapper || privateCompanyLeadsTransformer)(data?.data?.data),
        meta: data?.data?.meta,
      }
    },
    placeholderData: keepPreviousData,
  })

  return { data, meta, ...rest }
}

export default usePrivateCompanyLeads
